import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useDeletePerson = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (personId: string) =>
      await request(`${sport}/o/${organizationId}/persons/${personId}`, {
        method: "DELETE",
      }),
    onSuccess: async (response) => {
      if (!isDefaultOperationSucceeded(response)) {
        return;
      }

      await queryClient.invalidateQueries({ queryKey: ["persons", sport, organizationId] });
    },
  });
};
